const Helpers = require("./util/ParserHelpers");
const macroData = require("./util/BatexCommands");

const createMacro = function(inMath, data) {
	return function(ps) {
		// Take all white space coming after the command and consider it together
		// with the macro instead. This makes macros using block equations work
		// better, since block equations suppress a newline after them.
		const ws = Helpers.parseAndIgnoreSpace(ps);
		// Also take all text before this one, so that we don't accidentally mark
		// macro'd operators as unary.
		const preText = ps.text.slice(0, ps.pos);
		const newPs = ps.withText(preText + data + ws, ps.pos);
		const parse = inMath ? ps.parseMath : ps.parseNonmath;
		return parse(newPs) || false;
	};
};

const setupMacros = function(inMath, table) {
	const result = {};
	for (const name in table) {
		result[name] = createMacro(inMath, table[name]);
	}
	return result;
};

const nonmathMacros = setupMacros(false, macroData.nonmath);
const mathMacros = setupMacros(true, macroData.math);

module.exports = {
	nonmath: nonmathMacros,
	math: mathMacros,
};
